require('new_design/common/book_new_camp_form.js.coffee');
